'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'

const STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'archived', label: 'Archived' },
  { value: 'finalised', label: 'Finalised' },
  { value: 'pending', label: 'Pending' },
  { value: 'pending requisition', label: 'Pending requisition' },
  { value: 'pending approval', label: 'Pending approval' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'accepted', label: 'Accepted' },
  { value: 'accepted e.c.', label: 'Accepted e.c.' },
  { value: 'accepted f.c.', label: 'Accepted f.c.' },
  { value: 'approved', label: 'Approved' }
]

const SELECT_WIDTH = 360

type FormEvoNotificationStatusSelectProps = {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export const FormEvoNotificationStatusSelect = ({
  value,
  onChange,
  disabled = false
}: FormEvoNotificationStatusSelectProps) => {
  return (
    <div data-testid="FormEvoNotificationStatusSelect" style={{ width: SELECT_WIDTH }}>
      <ReactSelectMenu
        label="Select statuses"
        items={STATUS_OPTIONS}
        value={STATUS_OPTIONS.find((option) => option.value === value) || null}
        onChange={(option: { value: string } | null) => onChange(option?.value ?? '')}
        labelKey="label"
        valueKey="value"
        showIdInResults={false}
        searchable={false}
        name="formEvoNotificationBehaviourStatus"
        disabled={disabled}
        menuWidth={`${SELECT_WIDTH}px`}
      />
    </div>
  )
}
